<template>
  <div>
    <nuxt />
    <global-layout />
  </div>
</template>

<script>
import mixinCountNewMessages from '~/marketplace-front-core/mixin/countNewMessages'
import GlobalLayout from '~/marketplace-front-core/components/layout/GlobalLayout'

export default {
  components: { GlobalLayout },
  mixins: [mixinCountNewMessages],
  data () {
    return {
      mobileMenuVisible: false,
      defaultLocale: process.env.lang
    }
  },
  head () {
    return {
      meta: [
        { name: 'robots', content: 'noindex, nofollow' }
      ],
      htmlAttrs: {
        class: 'html-admin'
      }
    }
  }
}
</script>
